import { useAccount } from '@/features/auth';
import { useGetManagers } from '@/features/managers';
import { Departments } from '@/types';

export function useContentManagerId(department: Departments) {
  const {
    data: accountData,
    isLoading: isAccountLoading,
    isFetched: isAccountFetched,
  } = useAccount();

  const isAccount = Boolean(accountData?.account);

  const {
    data: managersData,
    isLoading: isManagersLoading,
    isFetched: isManagersFetched,
  } = useGetManagers({
    department,
    config: { enabled: isAccountFetched && isAccount },
  });

  // Account API is scoped by managerId; backend lists materials per manager._id.
  // Until a manager picker exists in the UI, we use the first manager in the department.
  const managerId = isAccount ? managersData?.managers?.[0]?._id : undefined;

  const isAuthResolved = isAccountFetched && (!isAccount || isManagersFetched);

  const isReady = isAuthResolved && (!isAccount || Boolean(managerId));
  const needsManager = isAuthResolved && isAccount && !managerId;

  return {
    managerId,
    isAccount,
    isLoading: isAccountLoading || (isAccount && isManagersLoading),
    isAuthResolved,
    isReady,
    needsManager,
  };
}
